import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import styles from '@Components/loading-toast/loading-toast.module.scss';
import {useAppSelector} from '@/hooks';
import {ToastContent} from '@Components/feedback-toast/toast-content/toast-content';
import {useIsMounted} from '@Hooks/useIsMounted';
import type {FeedbackReaction} from '@Components/feedback-toast/feedback-toast.types';
import type {CreditUsage} from '@Components/feedback-toast/toast-content/toast-content.types';

export interface FeedbackToastProps {
  onFeedbackReaction: (reaction: FeedbackReaction) => Promise<void>;
  onFeedbackTextInput: (feedback: string) => Promise<void>;
  reactionPageHeaderTitle: string;
  reactionPageHeaderIcon: string;
  feedbackInputHeaderTitle: string;
  feedbackInputHeaderIcon: string;
  feedbackInputPlaceholder: string;
  postSubmissionText: string;
  creditUsage?: CreditUsage;
}

export function FeedbackToast({...props}: FeedbackToastProps): ReactElement {
  const hasMounted = useIsMounted();
  const [showFeedbackToast, setShowFeedbackToast] = useState(true);
  const currentLoading = useAppSelector((state) => {
    return state.loadingToast.currentLoading;
  });

  const updateShowFeedbackToast = (state: boolean): void => {
    setShowFeedbackToast(state);
  };

  useEffect(() => {
    if (currentLoading.show) {
      updateShowFeedbackToast(false);
    }
  }, [currentLoading]);

  const getWrapperClasses = (): string => {
    return `radius-8 ${styles.wrapper}
     ${showFeedbackToast ? styles.in : styles.out}
     ${hasMounted.current ? styles.doAnimate : ''}`;
  };

  return (
    <div className={getWrapperClasses()}>
      <ToastContent
        setShowFeedbackToast={updateShowFeedbackToast}
        {...props}
      />
    </div>
  );
}
